/**
 * CALENDAR JS
 *
 * DATA TO BE STORED IN THE BACKEND FOR THIS:
 * - start month (stored as part of calendar entry data)
 * - calendar entries
 *
 */
import $ from 'jquery';
import aon_craft_sliders from './aon_craft_sliders.js';
import aon_craft_utils from './aon_craft_utils.js';
window.jQuery = $;

export default {
    init() {
        /*
         * Initialise calendar UI, data
         * UI interaction functions
         */
        console.log( 'Calendar widget - init' );

        // Calendar mode add_edit_activities / activity_types...
        
        var switchCalendarMode = ( mode ) => { // Function defined using arrow method to gain access to main 'this'
            if ( mode == 'add_edit_activities' ) {
                this.calendar_mode = 'add_edit_activities';
                //$( '.calendar' ).addClass( 'add_edit_activities' ).removeClass( 'activity_types' );
            } else if ( mode == 'activity_types' ) {
                this.calendar_mode = 'activity_types';
                //$( '.calendar' ).addClass( 'activity_types' ).removeClass( 'add_edit_activities' );
                
            }
            //console.log( 'calendar_mode: ' + mode );
        }
        switchCalendarMode( 'add_edit_activities' );
        
        // Variable to contain calendar entries
        this.aon_calendar_entries = []; 
        
        // Set Calendar Start Month via menu change and Render Calendar...
        this.calendar_start_month = 1;
        $( '#calendar_start_month' ).val( this.calendar_start_month );
        
        $( 'body' ).on( 'change', '#calendar_start_month', ( event ) => { // Function defined using arrow method to gain access to main 'this'
            this.calendar_start_month = $( '#calendar_start_month' ).val();
            // The above won't work as it gets overwritten by the following renderCalendar function call, we need to update the start month in the saved data instead.
            // So we need to update the 'aon_calendar_entries' array and then push this updated array back into the hidden 'calendar_src_data_field' so that the new start month is used when 'loadData' is called.
            // This is a bit less than optimal but the consequences of my decision to set the 'calendar_start_month' as a parameter on each of the entries that goes into the array, ideally I should have modified
            // the json format to allow this to be a separate parameter to the actual calendar entry data.
            this.updateCalendarStartMonth( this.calendar_start_month );
            this.renderCalendar();
            //event.preventDefault();
        });

        this.months = [];
        
        // Render Calendar...
        this.renderCalendar();
        
        
        /*
         * Add / Edit Modal interaction...
         */
        
        // Calendar entry hover / highlighting...
        $( 'body' ).on( 'mouseenter', '.calendar_entry a', function() {
            if ( !$( this ).parents( '.calendar' ).hasClass( 'activity_types' ) && !$( this ).parents( '.calendar' ).hasClass( 'readonly' ) ) { // If not setting Activity Types or Readonly (Business Plan) mode
                var entry_targ_class = $( this ).attr( 'class' );
                entry_targ_class = entry_targ_class.replace( 'income', '' ); // Strip off income / cost classes
                entry_targ_class = entry_targ_class.replace( 'cost', '' ); // to get only specific targer class
                entry_targ_class = entry_targ_class.replace( 'section_1', '' ); // to get only specific targer class
                entry_targ_class = entry_targ_class.replace( 'section_2', '' ); // to get only specific targer class
                $( '.' + entry_targ_class.trim() ).addClass( 'hi' );
				
				$( this ).find( $( '.calendar-entry-edit-tooltip' ) ).remove();
				var edit_tooltip = $( '.calendar-entry-edit-tooltip.hide' ).clone();
				edit_tooltip.removeClass( 'hide' );
				$( this ).append( edit_tooltip );
            }
        });

        $( 'body' ).on( 'mouseleave', '.calendar_entry a', function() {
            $( '.calendar_entry a' ).removeClass( 'hi' );
			$( this ).find( $( '.calendar-entry-edit-tooltip' ) ).remove();
        });
		
		/*$( "li" ).hover(
			function() {
				$( this ).append( $( "<span> ***</span>" ) );
			}, 
			function() {
				$( this ).find( "span" ).last().remove();
			}
		);*/
		/*$( 'body' ).on( 'hover', '.calendar_entry a', function( event ) {
			var edit_tooltip = $( '.calendar-entry-edit-tooltip' ).clone();
			edit_tooltip.removeClass( 'hide' );
			function() {
				$( this ).append( edit_tooltip );
			}, 
			function() {
				$( this ).find( edit_tooltip ).last().remove();
			}
			
			var edit_tooltip = $( '.calendar-entry-edit-tooltip' );
			$( '.calendar-entry-edit-tooltip' ).remove();
			console.log( 'edit_tooltip 1: ' );
			console.log( edit_tooltip );
			edit_tooltip.removeClass( 'hide' );
			console.log( 'edit_tooltip 2: ' );
			console.log( edit_tooltip );
        });*/
		
		
        
        var add_edit_modal_mode = '';
        
        // Click to Edit existing calendar entry modal link...
        $( 'body' ).on( 'click', '.calendar_entry a', function( event ) {
            //if ( !$( this ).closest( '.calendar' ).hasClass( 'readonly' ) ) { // If not Readonly (Business Plan) mode
            if ( !$( 'ul.calendar' ).hasClass( 'readonly' ) ) { // If not Readonly (Business Plan) mode
                console.log( 'Calendar in Full Read-Write mode' );
				$( this ).find( $( '.calendar-entry-edit-tooltip' ) ).remove();
                add_edit_modal_mode = 'edit';
                var name = $( this ).text();
                var start = $( this ).attr( 'data-calendar-entry-start-month' );
                var duration = $( this ).attr( 'data-calendar-entry-duration' );
                var id = $( this ).attr( 'data-calendar-entry-id' );
                var section = $( this ).attr( 'data-calendar-entry-section' );
                $( '#calendar_add_edit_entry_modal #calendar_entry_title_field' ).val( name );
                $( '#calendar_add_edit_entry_modal #calendar_entry_start_field' ).val( start );
                $( '#calendar_add_edit_entry_modal #calendar_entry_duration_field' ).val( duration );
                $( '#calendar_add_edit_entry_modal #calendar_entry_id' ).val( id );
                $( '#calendar_add_edit_entry_modal #calendar_entry_section' ).val( section );

                //console.log( 'Start opening Calendar Modal...');
                openCalendarModal();
                //console.log( 'Done opening Calendar Modal...');
            } else {
                console.log( 'Calendar in Read-only mode' );
            }
            
            event.preventDefault();
        });
		
		
        var openCalendarModal = () => { // Function defined using arrow method to gain access to main 'this'
            // Open specific modal depending on whether we're adding / editing entries or setting activity types
            console.log( 'Called opening Calendar Modal...');
            if ( this.calendar_mode == 'add_edit_activities' ) {
                $( '#calendar_add_edit_entry_modal' ).foundation( 'open' );
            }
        }
        
        var renderActivityTypes = () => { // Function defined using arrow method to gain access to main 'this'
                
                // Clear any added slides before generating to avoid duplication / multiplication!
                $( '#calendar_activities_type_slider .activity-slide' ).remove();
                
                // Get activities and render to slider...
                $.each( this.aon_calendar_entries, function( index ) {
                    var activity_slider_entry = '';
                    activity_slider_entry += '<li class="orbit-slide activity-slide activity-slide-' + index + ' text-center" data-activity-entry-id="' + index + '">';
                    activity_slider_entry += '    <div class="row align-center top-margin-zero bottom-margin-zero block_text ' + this.activity_type + '">';
                    activity_slider_entry += '      <div class="columns small-12 medium-10">';
                    activity_slider_entry += '          <div class="block flex-container text-center">';
                    activity_slider_entry += '              <h4 class="align-self-middle flex-child-auto">' + this.name + '</h4>';
                    activity_slider_entry += '          </div>';
                    activity_slider_entry += '      </div>';
                    activity_slider_entry += '    </div>';
                    activity_slider_entry += '</li>';
                    //console.log( 'activity_slider_entry: ' + activity_slider_entry); 
                    
                    // Add slide...
                    addSlide( 'calendar_activities_type_slider', activity_slider_entry, '.start-slide' );
                    // We append activity buttons to the new slide by cloning the source element '.activity-type-buttons-source',
                    // this keeps the markup in the template so that 'income' / 'cost' can be in the correct language string.
                    $( '.activity-type-buttons-source' ).clone().appendTo( '.activity-slide-' + index + ' .columns' ).removeClass( 'activity-type-buttons-source' ).addClass( 'activity-type-buttons' );
                });
                
                aon_craft_sliders.sliderInit( 'calendar_activities_type_slider' ); 
                aon_craft_sliders.getActiveSlideNumber( 'calendar_activities_type_slider' ); // Send ID of slider without the '#'
                aon_craft_sliders.sliderChange( 'calendar_activities_type_slider' );
                
        }
        
        function addSlide( a, b , c ) {
            aon_craft_sliders.sliderAddSlide( a, b, c );
        }
        
        // Click on Activity Type Income / Cost links...
        $( 'body' ).on( 'click', '.activity-type-buttons a', function( event ) {
            //console.log( 'Clicked on activity-type-buttons a - START' + $( this ).attr( 'class' ) );
            var c = $( this ).attr( 'class' );
            if ( c == 'button income' ) {
                var entry_id = $( '.activity-slide.is-active' ).attr( 'data-activity-entry-id' );
                setActivityType( entry_id, 'income' );
                $( '.activity-slide.is-active .block_text' ).removeClass( 'cost' ).addClass( 'income' );
                $( '#calendar_activities_type_slider .orbit-next' ).removeClass( 'do_not_proceed' ).removeAttr( 'disabled' );
                //console.log( 'Clicked on activity-type-buttons a - INCOME' );
            } else if ( c == 'button cost' ) {
                var entry_id = $( '.activity-slide.is-active' ).attr( 'data-activity-entry-id' );
                setActivityType( entry_id, 'cost' );
                $( '.activity-slide.is-active .block_text' ).removeClass( 'income' ).addClass( 'cost' );
                $( '#calendar_activities_type_slider .orbit-next' ).removeClass( 'do_not_proceed' ).removeAttr( 'disabled' );
                //console.log( 'Clicked on activity-type-buttons a - COST' );
            }
            event.preventDefault();
            
            // Check if all activity slides have cost or income classes applied,
            // if so then enable 'next' button to allow user to proceed...
            var enable_next = false;
            $( '#calendar_activities_type_slider .activity-slide' ).each( function( index, element ) {
                if ( $( '.block_text', this ).hasClass( 'income' ) || $( '.block_text', this ).hasClass( 'cost' ) ) {
                    enable_next = true;
                } else {
                    enable_next = false;
                }
            });
            
            if ( enable_next === true ) {
                $( '.calendar_activity_types_next' ).removeClass( 'disabled' );
            }
            
        });
     
        
        var setActivityType = ( entry_id, activity_type ) => {
            this.aon_calendar_entries[ entry_id ][ 'activity_type' ] = activity_type;
            this.renderCalendarEntries();
        }

        // Click on Add calendar entry modal link...
        $( 'body' ).on( 'click', '.calendar_entry_add_edit a', function( event ) {
            add_edit_modal_mode = 'add';
            event.preventDefault();
        });

        // 'Save' button click within calendar entry modal...
        $( 'body' ).on( 'click', '#save_calendar_entry', function( event ) {
            // Save data to existing
            var id = $( '#calendar_add_edit_entry_modal #calendar_entry_id' ).val();
            var name = $( '#calendar_add_edit_entry_modal #calendar_entry_title_field' ).val();
            var start_month = $( '#calendar_add_edit_entry_modal #calendar_entry_start_field' ).val();
            var duration = $( '#calendar_add_edit_entry_modal #calendar_entry_duration_field' ).val();
            var section = $( '#calendar_add_edit_entry_modal #calendar_entry_section' ).val();
            if ( add_edit_modal_mode == 'edit' ) {
                // Update existing entry to entries array - if req values all complete...
                if ( id != '' && name != '' && start_month != '' && duration != '' ) {
                    saveExistingCalendarEntry( id, name, start_month, duration, section );
                }
            } else if ( add_edit_modal_mode == 'add' ) {
                // Add new entry to entries array - if req values all complete...
                if ( name != '' && start_month != '' && duration != '' ) {
                    saveNewCalendarEntry( name, start_month, duration, section );
                }
            } else if ( add_edit_modal_mode == 'delete' ) {
                // Delete...
                deletingExistingCalendarEntry( id );
            }
            
            event.preventDefault();
        });
        
        var saveExistingCalendarEntry = ( id, name, start_month, duration, section ) => { // Function defined using arrow method to gain access to main 'this'
            this.aon_calendar_entries[ id ][ 'calendar_start_month' ] = this.calendar_start_month;
            this.aon_calendar_entries[ id ][ 'name' ] = aon_craft_utils.removeHTMLTags( name );
            this.aon_calendar_entries[ id ][ 'start_month' ] = aon_craft_utils.removeHTMLTags( start_month );
            this.aon_calendar_entries[ id ][ 'duration' ] = aon_craft_utils.removeHTMLTags( duration );
            this.aon_calendar_entries[ id ][ 'section' ] = section;
            this.renderCalendarEntries();
            $( '#calendar_add_edit_entry_modal' ).foundation( 'close' );
            $( '.calendar_add_edit_next' ).removeClass( 'disabled' );
        }
        
        var saveNewCalendarEntry = ( name, start_month, duration, section ) => { // Function defined using arrow method to gain access to main 'this'
            //var new_entry = { name: name, start_month: start_month, duration: duration, activity_type: '' }
            this.aon_calendar_entries.push( { calendar_start_month: this.calendar_start_month, 
											 name: aon_craft_utils.removeHTMLTags( name ), 
											 start_month: aon_craft_utils.removeHTMLTags( start_month ), 
											 duration: aon_craft_utils.removeHTMLTags( duration ), 
											 activity_type: '', 
											 section: section } );
            this.renderCalendarEntries();
            $( '#calendar_add_edit_entry_modal' ).foundation( 'close' );
            $( '.calendar_add_edit_next' ).removeClass( 'disabled' );
            $( '.calendar_activity_types_next' ).addClass( 'disabled' );
        }
        
        var deletingExistingCalendarEntry = ( id ) => { // Function defined using arrow method to gain access to main 'this'
            this.aon_calendar_entries.splice( id, 1 );
            this.renderCalendarEntries();
            $( '#calendar_add_edit_entry_modal' ).foundation( 'close' );
            //$( '.calendar_add_edit_next' ).removeClass( 'disabled' );
            
            $( '#delete_entry' ).prop( 'checked', false ).trigger( 'change' );
			var save_text = $( '.modal_save_calendar_entry_text' ).val();
			//var delete_text = $( '.modal_delete_calendar_entry_text' ).val();
            $( '#save_calendar_entry ').text( save_text ); // Save
            $( '#save_calendar_entry ').removeClass( 'delete' );
            
        }
        
        
        // Add / Edit Entry modal open event...
        $( 'body' ).on( 'open.zf.reveal', '#calendar_add_edit_entry_modal', function() {
            if ( add_edit_modal_mode == 'edit' ) {
                $( '.edit', this ).show();
                $( '.add', this ).hide();
                $( '#delete_entry' ).prop( 'checked', false ).trigger( 'change' );
                var save_text = $( '.modal_save_calendar_entry_text' ).val();
				//var delete_text = $( '.modal_delete_calendar_entry_text' ).val();
            	$( '#save_calendar_entry ').text( save_text ); // Save
                $( '#save_calendar_entry ').removeClass( 'delete' );
                $( '.delete_entry_panel', this ).show();
            } else if ( add_edit_modal_mode == 'add' ) {
                $( '.edit', this ).hide();
                $( '.add', this ).show();
                $( '.delete_entry_panel', this ).hide();
                $( '#calendar_entry_title_field' ).val( '' );
                $( '#calendar_entry_start_field' ).val( '' );
                $( '#calendar_entry_duration_field' ).val( '' );
                $( '#calendar_entry_section' ).val( $( 'body' ).attr( 'id' ) );
            }
            $( '#calendar_entry_title_field' ).focus();
            //console.log( 'calendar_add_edit_entry_modal open' );
        });

        // Add / Edit Entry modal close event...
        $( 'body' ).on( 'closed.zf.reveal', '#calendar_add_edit_entry_modal', function() {
            $( '#calendar_entry_title_field' ).val( '' );
            $( '#delete_entry' ).prop( 'checked', false ).trigger( 'change' );
			var save_text = $( '.modal_save_calendar_entry_text' ).val();
			//var delete_text = $( '.modal_delete_calendar_entry_text' ).val();
            $( '#save_calendar_entry ').text( save_text ); // Save
            $( '#save_calendar_entry ').removeClass( 'delete' );
            //console.log( 'calendar_add_edit_entry_modal close' );
        });
        
        // Activity Type modal open event...
        $( 'body' ).on( 'open.zf.reveal', '#calendar_entry_activity_modal', function() {
            //console.log( 'calendar_entry_activity_modal open' );
        });
        
        // Activity Type modal close event...
        $( 'body' ).on( 'closed.zf.reveal', '#calendar_entry_activity_modal', function() {
            $('#calendar_activities_type_slider').foundation( 'changeSlide', true, $( '.start-slide' ), 0 );
            //console.log( 'calendar_entry_activity_modal close' );
        });
        
        
        
        /*
         * Next / Back buttons...
         */
        // 'calendar_activity_types_back' button click...
        $( 'body' ).on( 'click', '.calendar_activity_types_back', function( event ) {
            // Switch Calendar to regular 'add_edit_activities' mode...
            switchCalendarMode( 'add_edit_activities' );
            event.preventDefault();
        });
        
        // 'calendar_add_edit_next', 'calendar_your_calendar_back' button clicks...
        $( 'body' ).on( 'click', '.calendar_add_edit_next, .calendar_your_calendar_back', function( event ) {
            // Switch Calendar to 'activity_types' mode...
            switchCalendarMode( 'activity_types' );
            renderActivityTypes();
            event.preventDefault();
        });
        
        
        $( 'body' ).on( 'change', '#delete_entry', function( event ) {
            if ( $( '#delete_entry' ).prop( 'checked' ) ) {
				//var save_text = $( '.modal_save_calendar_entry_text' ).val();
				var delete_text = $( '.modal_delete_calendar_entry_text' ).val();
                $( '#save_calendar_entry ').text( delete_text ); // DELETE
                $( '#save_calendar_entry ').addClass( 'delete' );
                add_edit_modal_mode = 'delete';
                //console.log( 'DELETE' );
            } else {
				var save_text = $( '.modal_save_calendar_entry_text' ).val();
				//var delete_text = $( '.modal_delete_calendar_entry_text' ).val();
            	$( '#save_calendar_entry ').text( save_text ); // Save
                $( '#save_calendar_entry ').removeClass( 'delete' );
                add_edit_modal_mode = 'edit';
                //console.log( 'NOT DELETE' );
            }
            event.preventDefault();
        });
        
        
        
        
        // Check whether Activity Type has been applied to Activity before allowing 'orbit-next' button action to work...
        $( 'body' ).on( 'slidechange.zf.orbit', '#calendar_activities_type_slider', function( e, handle ) {
            // if active slide has activity type class added then proceed...
            var active_slide = $( '#calendar_activities_type_slider .orbit-slide.is-active ' );
            //console.log( active_slide );
            
            if ( active_slide.hasClass( 'activity-slide' ) && active_slide.not( '.start-slide' ) ) {
                //console.log( 'Not the start!' );
                if ( active_slide.children( '.block_text' ).hasClass( 'income') ) {
                    //console.log( 'Yep - Income!');
                    $( '#calendar_activities_type_slider .orbit-next' ).removeClass( 'do_not_proceed' ).removeAttr( 'disabled' );
                } else if (  active_slide.children( '.block_text' ).hasClass( 'cost') ) {
                    //console.log( 'Yep - Cost!');
                    $( '#calendar_activities_type_slider .orbit-next' ).removeClass( 'do_not_proceed' ).removeAttr( 'disabled' );
                } else {
                    //console.log( 'Nope!');
                    $( '#calendar_activities_type_slider .orbit-next' ).addClass( 'do_not_proceed' ).attr( 'disabled', 'disabled' );
                }
            } else {
                $( '#calendar_activities_type_slider .orbit-next' ).removeClass( 'do_not_proceed' ).removeAttr( 'disabled' );
                
            }
      
        });
        
        
        // Click on 'save_calendar_data' to submit completed data to backend storage...
        $( 'body' ).on( 'click', '.save_calendar_data', ( event ) => {
            this.saveData();
        });
        

    },
    
    renderCalendar() {
        // Render 12 months in Calendar starting on specific month...
        console.log( 'renderCalendar - start' );
        
        
        // Initialise Calendar entry data...
        this.loadData( 'load_live' );
        
        this.getMonthsInOrder();
        for( var i = 0; i < this.months.length; i++ ) {
            $( '.calendar' ).append( '<li class="column month_' + this.months[ i ][ 1 ] + ' ordered_month_' + i + '"><h3>' + this.months[ i ][ 0 ] + '</h3><ul class="nested menu"></li></li>' );
        }
        
        // Render entries...
        this.renderCalendarEntries( this.months );
        
        if ( this.aon_calendar_entries === '' ) {
            $( '.calendar_entry_add_edit' ).addClass( 'no_entries' );
        }
    },
    
    getMonthsInOrder() {
        /* 
         * We initally get all 12 months in order starting from January from the markup of the initial
         * 'calendar_start_month' dropdown which is rendered using the current language translation, 
         * we loop over this markup to extract and create a source array of months which is then sorted
         * to start via the desired start month. We also get the corresponding number of each month to
         * match against rather than relying on the literal month name which would otherwise cause
         * problems if the user switches languages...
         */
        //console.log( 'getMonthsInOrder - start' );
        
        // Empty the months array...
        this.months = []; 
        
        // Remove any existing months markup from the calendar...
        $( '.calendar li.column' ).remove();
        
        // Get months from source list and create temp data array...
        var months_src = [];
        var month_count = 1;
        //$( '#calendar_months_source li' ).each( function( index, element ) {
        $( '#calendar_start_month option' ).each( function( index, element ) {
            // Pushing into temp array: Name of Month name in current language in lowercase, numeric month order (january = 1 etc)...
            months_src.push( [ $( this ).text().toLowerCase(), month_count ] );
            month_count++;
        });
                
        // Create actual 'months' data array ordered from the desired starting month...
        var calendar_start_month = this.calendar_start_month;
        console.log( 'getMonthsInOrder() - this.calendar_start_month ' + calendar_start_month );
        var offset = calendar_start_month - 1;
        for( var i = 0; i < months_src.length; i++ ) {
            var pointer = ( i + offset ) % months_src.length;
            this.months.push( [ months_src[ pointer ][ 0 ], months_src[ pointer ][ 1 ] ] );
        }
        
    },
    
    
    renderCalendarEntries() {
        /*
         * Load / render existing entries to calendar...
         */
        //console.log( 'renderCalendarEntries - start' );
        //console.table( this.aon_calendar_entries );
        
        var months = this.months;
        
        // Remove any existing entries so that we don't re-render...
        $( '.calendar li.calendar_entry' ).remove();
        
        var entries_to_render = [];
        
        //console.table( this.aon_calendar_entries );
        // Sort the calendar entries by the duration descending so that we *try* to keep
        // longer duration entries in one line when spanning multiple months...
        this.aon_calendar_entries.sort( function( a, b ) {
            return parseFloat( b.duration ) - parseFloat( a.duration );
        } );
        //console.table( this.aon_calendar_entries );
		
        // Loop over entries array...
        var entry_count = 1;
        $.each( this.aon_calendar_entries, function( index ) {
            // Begin entry...            
            var aon_calendar_entry_link = '<a href="#edit_calendar_entry" data-calendar-entry-id="' + index + '" data-calendar-entry-duration="' + this.duration + '" data-calendar-entry-start-month="' + this.start_month + '" data-calendar-entry-section="' + this.section + '" class="entry_' + entry_count + ' ' + this.section + ' ' + this.activity_type + '" title="' + this.name + '">' + this.name + '</a>';
            
            var start_month_index = '';
            // Find matching month within two-dimensional array...
            for( var k = 0; k < months.length; k++ ) {
                if ( months[ k ][ 1 ] == this.start_month ) {
                    start_month_index = k;
                }
            }
      
            if ( this.duration > 1 ) {
                // Loop over duration to add multiple month entries... 
                for( var i = 0; i < this.duration; i++ ) {
                    
                    var entry_class = '';
                    if ( i === 0 ) {
                        entry_class = ' month_start';
                    } else if ( i === this.duration - 1 ) {
                        entry_class = ' month_end';   
                    } else {
                        entry_class = ' month_centre'; 
                    }
                    var loop_month = start_month_index + i;
                    $( 'li.ordered_month_' + loop_month + ' ul.nested.menu' ).append( '<li class="calendar_entry' + entry_class + '">' + aon_calendar_entry_link + '</li>' );
                    console.log( 'Add Calendar entry to Cal 2+ months');
                }
            
            } else {
                $( 'li.ordered_month_' + start_month_index + ' ul.nested.menu' ).append( '<li class="calendar_entry">' + aon_calendar_entry_link + '</li>' );
                console.log( 'Add Calendar entry to Cal 1 month');
            }
            
            entry_count++;
            
            console.log( 'Loop over Calendar entries array');
            
        });
        
        // If enable / disable Next button depending on whether entries exist...
        //calendar_add_edit_next
        if ( !this.aon_calendar_entries.length ) {
            $( '.calendar_add_edit_next' ).addClass( 'disabled' );
        } else {
            $( '.calendar_add_edit_next' ).removeClass( 'disabled' );
        }

    },
    
    setCalendarStartMonth() {
        // Set Calendar start month to the setting found in the first array item...
        if ( this.aon_calendar_entries && this.aon_calendar_entries.length ) {
            this.calendar_start_month = this.aon_calendar_entries[ 0 ][ 'calendar_start_month' ];
            console.log( 'this.aon_calendar_entries[ 0 ][ \'calendar_start_month\' ] --- ' + this.aon_calendar_entries[ 0 ][ 'calendar_start_month' ]);
        } else {
            //this.calendar_start_month = 1; // We don't need to set a default month here, the default is already set earlier on.
        }
        $( '#calendar_start_month' ).val( this.calendar_start_month );
        console.log( 'this.calendar_start_month: ' + this.calendar_start_month );
    },
    
    updateCalendarStartMonth( updated_month ) {
        // This function loops over the 'this.aon_calendar_entries' array and sets the 'calendar_start_month' parameter to a new month,
        // It then pushes the updated array back into the 'calendar_src_data_field' hidden field as stringified text
        console.log( 'updateCalendarStartMonth() - start' );
        
        var setNewCalendarStartMonth = ( id, updated_month ) => {
            console.log( 'updated_month: ' + updated_month );
            this.aon_calendar_entries[ id ][ 'calendar_start_month' ] = updated_month;
            console.log( 'this.aon_calendar_entries[ id ][ \'calendar_start_month\' ]: ' + this.aon_calendar_entries[ id ][ 'calendar_start_month' ] );
        }
        
        $.each( this.aon_calendar_entries, function( index ) {
            console.log( 'updateCalendarStartMonth() - looping' );
            // Loop over entries and change 'calendar_start_month' to 'updated_month'            
            console.log( this.calendar_start_month );
            setNewCalendarStartMonth( index, updated_month );
            //this.aon_calendar_entries[ index ][ 'calendar_start_month' ] = updated_month;
            //this.aon_calendar_entries[ id ][ 'calendar_start_month' ] = this.calendar_start_month;
            
        });
        // Push stringified array back into the hidden text field...
        var jsonDataString = JSON.stringify( this.aon_calendar_entries );
        console.log(jsonDataString);
        $( '#calendar_src_data_field' ).val( jsonDataString );
        
    },
    
    loadData( mode ) {
        /*
         * Set Data.
         * Load existing data from backend, a test JSON array or set default blank data...
         */
        
        // Load test JSON data array...
        if ( mode == 'load_test' ) {
            // Using temp JSON source for now...
            var aon_calendar_entries_json = '[';
                aon_calendar_entries_json += '{"calendar_start_month":"2","name":"Market Research","start_month":"2","duration":"1","activity_type":"","section":"section_1"},';
                aon_calendar_entries_json += '{"calendar_start_month":"2","name":"Create a great new product line","start_month":"1","duration":"3","activity_type":"","section":"section_1"},';
                aon_calendar_entries_json += '{"calendar_start_month":"2","name":"Pickle eggs","start_month":"6","duration":"1","activity_type":"","section":"section_1"}';
                aon_calendar_entries_json += ']';
                this.aon_calendar_entries = JSON.parse( aon_calendar_entries_json );
                $( '.calendar_add_edit_next' ).removeClass( 'disabled' );
        
        // Load JSON data from text field linked to backend...
        } else if ( mode == 'load_live' ) {
            if ( $( '#calendar_src_data_field' ).length > 0 && $( '#calendar_src_data_field' ).val() != '' ) {
                var aon_calendar_entries_json = $( '#calendar_src_data_field' ).val();
                this.aon_calendar_entries = JSON.parse( aon_calendar_entries_json );
                $( '.calendar_add_edit_next' ).removeClass( 'disabled' );
                console.log( 'loading calendar data' );
            }
            
        } else if ( mode == 'start' ) {
            
        }
        
        this.setCalendarStartMonth();
 
    },
        
    saveData() {
        // Call AJAX request to WP / Rest API
        // Save completed data to backend...
        var jsonDataString = JSON.stringify( this.aon_calendar_entries );
        console.log( 'jsonDataString: ' + jsonDataString );
        console.log( '1A / 2B CALENDAR AJAX - START' );
        var meta = { 'calendar_data' : jsonDataString };
        $.ajax({
            url: wpApiSettings.root + 'wp/v2/users/' + wpApiSettings.current_user_id,
            //processData: false,
            method: 'POST',
            //contentType: 'application/json; charset=utf-8',
            beforeSend: function ( xhr ) {
                xhr.setRequestHeader( 'X-WP-Nonce', wpApiSettings.nonce );
            },
            data: {
                'meta' : meta
            }
        }).done( function ( response ) {
            console.log( 'Response: ' );
            console.log( response );
        });
        console.log( '1A / 2B CALENDAR AJAX - END' );
        
        
        
        console.log( 'Saving data via AJAX, saving the following:' );
        console.table( this.aon_calendar_entries );
    },
}